import { CrudState } from "@/store/Crud/State";
export class State extends CrudState {
    theoryCourses = [];
    licenceClasses = [];
    drivingSchool = null;
    branches = [];
    languages = [];
    languagesLoading = false;
    languagesError = null;
    countries = [];
    countriesLoading = false;
    countriesError = null;
    previousLicenceClasses = [];
    previousLicenceClassesLoading = false;
    previousLicenceClassesError = null;
    selectedLicenseClass = null;
    selectedTheoryCourse = null;
    theoryCoursesLoading = false;
    licenceClassesLoading = false;
}
